import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './index.scss';
import {
    NOTIFICATION_TYPE_INFO,
    NOTIFICATION_TYPE_WARNING,
    NOTIFICATION_TYPE_ERROR,
} from '../../../../../config/consts';
import IconImportant from '../../../../components/IconImportant';
import IconAlert from '../../../../components/IconAlert';
import IconOk from '../../../../components/IconOk';
import OldMobile from '../../../../components/Responsive/OldMobile';
import Desktop from '../../../../components/Responsive/Desktop';

const NotificationIcon = props => {
    switch (props.type.toLowerCase()) {
        case NOTIFICATION_TYPE_INFO: {
            return (
                <React.Fragment>
                    <OldMobile>
                        <IconOk width={15} height={15} />
                    </OldMobile>
                    <Desktop>
                        <IconOk width={20} height={20} />
                    </Desktop>
                </React.Fragment>
            );
        }
        case NOTIFICATION_TYPE_WARNING: {
            return (
                <React.Fragment>
                    <OldMobile>
                        <IconImportant fill={'#E47F00'} width={15} height={15} />
                    </OldMobile>
                    <Desktop>
                        <IconImportant fill={'#E47F00'} width={20} height={20} />
                    </Desktop>
                </React.Fragment>
            );
        }
        case NOTIFICATION_TYPE_ERROR: {
            return (
                <React.Fragment>
                    <OldMobile>
                        <IconAlert fill={'#B10043'} width={15} height={15} />
                    </OldMobile>
                    <Desktop>
                        <IconAlert fill={'#B10043'} width={20} height={20} />
                    </Desktop>
                </React.Fragment>
            );
        }
        default: {
            return null;
        }
    }
};

const StaticNotification = props => {
    const classes = classNames({
        [styles.notificationBlock]: true,
        [styles.warning]: props.type === NOTIFICATION_TYPE_WARNING.toUpperCase(),
        [styles.error]: props.type === NOTIFICATION_TYPE_ERROR.toUpperCase(),
        [styles.info]: props.type === NOTIFICATION_TYPE_INFO.toUpperCase(),
    });
    return (
        <div className={classes}>
            <div className={styles.iconWrap}>
                <NotificationIcon type={props.type} />
            </div>
            <div className={styles.message}>{props.message}</div>
        </div>
    );
};

StaticNotification.propTypes = {
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};

export default StaticNotification;
